import axiosInstance from '../utils/api-util/utilApi'
import { IBatchProcessingPayload, IDataImportProcessingPayload } from '../models/Background.model'
import { FilterPayload, ISearchEmailLog } from '../models/sentEmailLog'
import { ApiResponse } from '../models/common.model'
import { GetAuditTrailLogRequestModel } from '../models/auditTrailLog.model'
import {
  IManualExceptionNotificationPreview,
  IManualExceptionNotificationSend,
} from '../models/manualExceptionNotification.model'

const config = { baseURL: process.env.REACT_APP_BACKGROUND_SERVICE_URL || '' }

export const getBatchProcessing = (data: IBatchProcessingPayload): Promise<any> => {
  return axiosInstance.post(`/BackgroundLog/filter`, data, config)
}

export const getRejectListErrorUploadACH = (id: string): Promise<any> => {
  return axiosInstance.get(`/DataImportProcess/GetRejectedDetailById/${id}`, config)
}

export const getListErrorUploadACH = (id: string): Promise<any> => {
  return axiosInstance.get(`/DataImportProcess/GetDetailById/${id}`, config)
}

export const getDataImportProcessing = (data: IDataImportProcessingPayload): Promise<any> => {
  return axiosInstance.post('/DataImportProcess/filter', data, config)
}

export const getListSentEmailResults = (payload: Partial<FilterPayload>): Promise<any> => {
  return axiosInstance.post(`/emailLogs/filter`, JSON.stringify(payload), config)
}

export const getListRecipients = (): Promise<ApiResponse<any>> => {
  return axiosInstance.get(`/emailLogs/listRecipients`, config)
}

export const getListErrorReasons = (): Promise<ApiResponse<any>> => {
  return axiosInstance.get(`/emailLogs/listMessageReasons`, config)
}

export const getListMessageSubjects = (): Promise<ApiResponse<any>> => {
  return axiosInstance.get(`/emailLogs/listMessageSubjects`, config)
}

export const searchEmailLog = (payload: Partial<ISearchEmailLog>): Promise<any> => {
  return axiosInstance.post(`/emailLogs/searchEmailLog`, JSON.stringify(payload), config)
}

export const getContentDetailEmail = (id: string): Promise<ApiResponse<any>> => {
  return axiosInstance.get(`/emailLogs/${id}`, config)
}

export const deleteDataImportProcessing = (id: string): Promise<any> => {
  return axiosInstance.delete(`/DataImportProcess/DeleteDataImportProcessing/${id}`, config)
}

export const getDataImportProcessingError = (id: string): Promise<any> => {
  return axiosInstance.get(`/DataImportProcess/GetDetailById/${id}`, config)
}

export const getAuditTrailLogs = (data: GetAuditTrailLogRequestModel): Promise<ApiResponse<any>> => {
  return axiosInstance.post(`/auditTrailLogs/filter`, JSON.stringify(data), config)
}

export const getAuditTrailLogTableNames = (): Promise<ApiResponse<any>> => {
  return axiosInstance.get(`/auditTrailLogs/listTableNames`, config)
}

export const getAuditTrailLogActions = (): Promise<ApiResponse<any>> => {
  return axiosInstance.get(`/auditTrailLogs/listActions`, config)
}

export const getAuditTrailLogUsers = (data: Partial<GetAuditTrailLogRequestModel>): Promise<ApiResponse<any>> => {
  return axiosInstance.post(`/auditTrailLogs/listUsers`, JSON.stringify(data), config)
}

export const previewManualExceptionEmails = (): Promise<ApiResponse<IManualExceptionNotificationPreview>> => {
  return axiosInstance.get(`/emailLogs/exceptionEmails/preview`, config)
}

export const sendManualExceptionEmails = (): Promise<ApiResponse<IManualExceptionNotificationSend>> => {
  return axiosInstance.post(`/emailLogs/exceptionEmails/send`, {}, config)
}
